import {Component} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Toast} from '../../../classes/toast';
import {ToastService} from '../../../shared/toast.service';
import { AsyncPipe, NgClass } from '@angular/common';
import {Severity} from '../../../enums/severity';
import {NgIcon, provideIcons} from '@ng-icons/core';
import {
  heroCheckCircle,
  heroExclamationTriangle,
  heroInformationCircle,
  heroXCircle
} from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-toast',
  imports: [
    AsyncPipe,
    NgClass,
    NgIcon
],
  templateUrl: './toast.component.html',
  standalone: true,
  styleUrl: './toast.component.scss',
  viewProviders: [provideIcons({heroExclamationTriangle, heroInformationCircle, heroXCircle, heroCheckCircle})]
})
export class ToastComponent {
  toasts: BehaviorSubject<Toast[]>;
  severity: typeof Severity = Severity;

  constructor(private _toastService: ToastService) {
    this.toasts = this._toastService.toasts$;
  }
}
